import React from 'react';
import { Main } from './styles';

const LoginSection = ({ children }) => {
  return <Main>{children}</Main>;
};

export default LoginSection;
